import axios from "axios";

export const createIndicator = async (username, indicatorVOToCreate) => {
    try {
        const {data} = await axios.post("/api/indicator/create", {username, indicatorVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllIndicators = async (username) => {
    try {
        const {data} = await axios.get("/api/indicator/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllIndicatorsForTopicArea = async (username, topicAreaExternalReference) => {
    try {
        const {data} = await axios.get("/api/indicator/viewIndicatorsForDropDown?username=" + username + "&key=" + topicAreaExternalReference);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateIndicator = async (username, indicatorVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/indicator/update", {username, indicatorVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteIndicator = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/indicator/delete", {data: {username, externalReference}})
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveIndicator = async (username, indicatorExternalReference) => {
    try {
        const {data} = await axios.post("/api/indicator/view", {username, indicatorExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
